import React, { useState } from 'react'
import { strCol, intCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo, getCauseCodeMap } from 'core'
import { connect } from 'react-redux'
import {
  getMelCauseCode,
  saveMelCauseCode,
  deleteMelCauseCode,
} from 'api/pgads.js'

import CommonScreen from './CommonScreen'
import { Button, Select, Input } from 'antd'
import styled from 'styled-components'

const TableTD = styled.td`
  text-align: end;
`

const headers = [
  intCol({
    ident: 'causeCode',
    display: 'Cause Code',
    isKey: true,
    width: 700,
    sortOrder: 'asc',
    ellipsis: true,
  }),
  strCol({
    ident: 'melSystemCode',
    display: 'Mel System Code',

    width: 150,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'melSubSystemCode',
    display: 'Mel Sub System Code',

    width: 150,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'engSystemDesc',
    display: 'Eng System Desc',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'engSubSystemDesc',
    display: 'Eng Sub System Desc',
    isKey: false,
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'Mel Causecode'

const MelCauseCode = ({ causeCodeMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Causcode :</TableTD>
            <td>
              <Select
                style={{ width: '100%' }}
                value={insertData.causeCode}
                onChange={value =>
                  setInsertData({ ...insertData, causeCode: value })
                }
              >
                {Object.keys(causeCodeMap).map(k => (
                  <Select.Option key={k} value={k}>
                    {k}-{causeCodeMap[k]}
                  </Select.Option>
                ))}
              </Select>
            </td>
            <TableTD>Mel System Code :</TableTD>
            <td colSpan={1}>
              <Input
                style={{ width: '100%' }}
                value={insertData.melSystemCode}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    melSystemCode: e.target.value,
                  })
                }}
              />
            </td>
            <TableTD>Mel Sub System Code :</TableTD>
            <td colSpan={1}>
              <Input
                style={{ width: '100%' }}
                value={insertData.melSubSystemCode}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    melSubSystemCode: e.target.value,
                  })
                }}
              />
            </td>
          </tr>
          <tr>
            <TableTD>Eng System Desc :</TableTD>
            <td colSpan={1}>
              <Input
                style={{ width: '100%' }}
                value={insertData.engSystemDesc}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    engSystemDesc: e.target.value,
                  })
                }}
              />
            </td>
            <TableTD>Eng Sub System Desc :</TableTD>
            <td colSpan={3}>
              <Input
                style={{ width: '100%' }}
                value={insertData.engSubSystemDesc}
                onChange={e => {
                  setInsertData({
                    ...insertData,
                    engSubSystemDesc: e.target.value,
                  })
                }}
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const headerWithFormatter = headers.map(header =>
    header.ident === 'causeCode'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) =>
            value ? `${value}-${causeCodeMap[value]}` : value,
          sortIndexGetter: ({ rowData }) => rowData.causeCode,
          // causeCodeMap[rowData.causeCode] ||
        }
      : header
  )

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={saveMelCauseCode}
      retrieveTask={getMelCauseCode}
      deleteTask={deleteMelCauseCode}
      altBy={d => d.causeCode}
      autoRetrieve
      sortOptions={headers}
      insertComp={insertEvent && insertComp}
      insertCompHeight={130}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={60}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  causeCodeMap: getCauseCodeMap(state),
})

export default connect(mapStateToProps)(MelCauseCode)
